module.exports = __webpack_public_path__ + "static/media/info-white.3fb0bad4.svg";